<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="col-xs-12 text-left form-group">
          <div class="btn btn-default btn-table-title" @click="crElement()">新增菜單圖示</div>
        </div>
        <!--
        <div class="form-group">
          <select class="form-control h-38" v-model="selectActive">
            <option value="99">全部</option>
            <option value="1">啟用</option>
            <option value="0">停用</option>
          </select>
        </div>
        -->
      </div>
      <div class="col-sm-6 text-right">
        <!--
        <div class="form-group">
          <select class="form-control h-38">
            <option value="1">名稱</option>
          </select>
        </div>
        <div class="form-group search-bar">
          <div class="input-group">
            <input class="form-control" type="text" v-model="searchInput">
            <span class="input-group-addon c-pointer" @click="getAdList()"><i class="fa fa-search"></i></span>
          </div>
        </div>
        -->
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">圖示</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">ID</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">顯示</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">名稱</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">描述</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">排序</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
          </tr>
          </thead>
          <tbody>
          <tr class="even" role="row" v-for="(img, index) in imgList">
            <!-- cloumn 0 -->
            <td class="sorting_1">{{index + 1}}</td>
            <!-- column 1-->
            <td>
              <div><img class="img img-responsive" :src="img.url" width="30"></div>
            </td>
            <td>
              <div>{{img.icon_id}}</div>
            </td>
            <td>
              <label class="label label-success" v-if="img.is_visible">顯示</label>
              <label class="label label-danger" v-else>隱藏</label>
            </td>
            <td>
              {{img.name}}
            </td>
            <td>
              {{img.description}}
            </td>
            <td>
              {{img.sort}}
            </td>
            <td>
              <button class="btn btn-primary" @click="upElement(img.icon_id)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                :groupAmount="groupAmount" :clickPage="clickPage"
      >
      </paginate>
    </div>
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import matcherModal from '../../../elements/Modal.vue'
export default{
  props: {
    imgList: Array,
    imgMeta: Object,
    tab: Number,
    getProductImageList: Function
  },
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      selectActive: 99,
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 0,
      count: 20,
      searchInput: '',
      delOption: {
        id: 'delModal',
        title: '刪除綁定',
        body: '刪除綁定，此處刪除等同刪除該項目所有關聯！<br>刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delBind'
          }
        ]
      },
      curId: 0
    }
  },
  methods: {
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    delModalOpen (img) {
      this.delOption.title = '刪除' + img.name + '綁定'
      this.curId = img.item_id
    },
    trigger (event) {
      if (event === 'delBind') {
        this.delBind()
      }
    },
    delBind () {
      // console.log('del')
      var self = this
      var url = 'store/' + this.$route.params.store_id + '/itemBinding?item_id=' + this.curId + '&type=' + this.tab
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.curId = 0
          self.getProductImageList()
        }
      })
    },
    upElement (settingId) {
      const bId = this.$route.params.brand_id
      const sId = this.$route.params.store_id
      switch (this.tab) {
        case 99:
          this.$router.push(`/upProductIcon/${bId}/${sId}/${settingId}`)
          break
      }
    },
    crElement () {
      // console.log(this.tab)
      const bId = this.$route.params.brand_id
      const sId = this.$route.params.store_id
      switch (this.tab) {
        case 99:
          this.$router.push(`/crProductIcon/${bId}/${sId}`)
          break
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getProductImageList(index)
    },
    getAdList () {
      var self = this
      var data = {
        page: this.tableIndex,
        size: this.count
      }
      var url = '/store/' + this.$route.params.store_id + '/bannerList?list_sort=end_time DESC,sort ASC&page=' + data.page + '&size=' + data.size
      if (parseInt(this.selectActive, 10) !== 99) url = url + '&is_active=' + this.selectActive
      if (this.searchInput.trim()) url = url + '&name=' + this.searchInput
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.adList = response.data.list
          self.total = response.data.list_total
        }
      })
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    tabName () {
      switch (this.tab) {
        case 2: return '配料'
        case 20: return '配料群組'
        case 10: return '商品分類'
        case 1: return '商品'
        case 11: return '品項選擇區'
        case 3: return '套餐'
      }
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    selectActive () {
      this.tableIndex = 1
      this.searchInput = ''
    },
    tab () {
      this.tableIndex = 1
    },
    imgMeta () {
      this.total = this.imgMeta.total
      this.count = this.imgMeta.size
    }
  }
}
</script>
<style lang="sass">
  .img-ad-table
    height: 50px
</style>



// WEBPACK FOOTER //
// ProdIconTable.vue?570f9261